import { FieldKey, t } from '../i18n';
import { markers, ReservedWords, reservedWords, tokenize } from '../models/common';

const triggers: ReservedWords = {
    words: markers.map((x) => x.text),
    inflected: markers.map((x) => x.text),
};

const validateWords = (reservedWordLists: ReservedWords[], value: string, field: FieldKey): string => {
    const words = tokenize(value);
    for (const reservedWordList of reservedWordLists) {
        if (reservedWordList.inflected.some((reservedWord) => words.includes(reservedWord))) {
            const quotedReservedWords = reservedWordList.words.map((x) => `«${x}»`).join(', ');
            return t('reserved-words', { field: t(field), words: quotedReservedWords });
        }
    }
    return '';
};

export const validateReservedWordsAndPhrases = (
    value: string,
    isAdmin: boolean,
    field: FieldKey = 'field-common',
): string => {
    const wordLists = isAdmin ? [triggers] : [reservedWords, triggers];
    return validateWords(wordLists, value, field);
};

export const validateReservedWords = (value: string, field: FieldKey = 'field-common'): string =>
    validateWords([reservedWords], value, field);

export default validateReservedWordsAndPhrases;
